<template>
  <div class="gift-item" @click.capture="showModal" style="position:relative">
    <div class="bg-norepeat bg-cover fill-parent" v-lazy:background-image="product.PhotoUrl"></div>
    <div class="item-details with-image">
      <h2 class="item-title">
        {{ category.Name }}
        <span
          :class="{
            new: product.Status == 1,
            popular: product.Status == 2,
            sold: product.Status == 3
          }"
          class="badge"
        >{{ product.Status | formatStatus(this) }}</span>
      </h2>
      <p v-html="product.ShortDescription"></p>
    </div>
    <div class="item-img">{{ category.Price | formatMoney(currencySign) }}</div>
    <div v-if="product.Status == 3" class="sold-out">
      <h4>{{$t("message.soldOut")}}</h4>
    </div>
    <AddToCart
      v-if="isModalVisible"
      :price="category.Price"
      :product-id="category.ProductID"
      :product="product"
      :modifiers="modifiers"
    />
  </div>
</template>

<script>
import AddToCart from "./GiftAddToCartMobile";
import shared from "../../../sharedscripts/shop/products/Product.js";
export default {
  name: "Product",
  components: { AddToCart },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  computed: {
    ...shared.computed,
  },
  methods: {
    ...shared.methods
  }
};
</script>
